const UserInfo = () => {
  return (
    <div className="flex items-center gap-3 border border-lightGray px-8 pt-2.5 pb-3">
      <picture className="relative h-10 w-10">
        <img
          src="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50"
          alt=""
          className="w-full rounded-full border-2 border-secondary"
        />
        <div className="absolute top-0 right-0 h-3 w-3 rounded-full border-2 border-white bg-secondary"></div>
      </picture>
      <div>
        <p className="font-pop text-lg font-bold">JustinRusho</p>
        <p className="font-pop text-[15px] text-chatLightGray">
          Last seen 2m ago
        </p>
      </div>
    </div>
  );
};

export default UserInfo;
